import type { ChatServiceConfiguration } from '../../services/chatService';

function normalizeBearerToken(token: string): string {
    const trimmed = token.trim();
    if (!trimmed.length) {
        return trimmed;
    }

    return trimmed.startsWith('Bearer ') ? trimmed : `Bearer ${trimmed}`;
}

export function resolveEffectiveChatConfiguration(
    chatConfigurationWithLanguage: ChatServiceConfiguration | null,
    authOverride: string
): ChatServiceConfiguration | null {
    if (!chatConfigurationWithLanguage) {
        return chatConfigurationWithLanguage;
    }

    if (!authOverride) {
        return chatConfigurationWithLanguage;
    }

    return {
        ...chatConfigurationWithLanguage,
        getAuthorizationToken: () => normalizeBearerToken(authOverride)
    };
}

export function applyLanguageToChatConfiguration(
    chatConfiguration: ChatServiceConfiguration | null,
    activeLanguage: string
): ChatServiceConfiguration | null {
    if (!chatConfiguration || !activeLanguage) {
        return chatConfiguration;
    }

    const nextHeaders = {
        ...(chatConfiguration.headers ?? {})
    };

    if (nextHeaders.language === activeLanguage && nextHeaders.lang === activeLanguage) {
        return chatConfiguration;
    }

    nextHeaders.language = activeLanguage;
    nextHeaders.lang = activeLanguage;

    return {
        ...chatConfiguration,
        headers: nextHeaders
    };
}
